// 3D Pool Models from Lonestar Fiberglass Components

export const poolModels = {
  small: [
    {
      name: "The Lincoln",
      size: "23' x 11'",
      image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-lincoln.jpg",
      description: "Compact yet inviting space for relaxation"
    },
    {
      name: "The Miami",
      size: "21'4\" x 10'9\"",
      image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-miami.jpg",
      description: "Compact yet stylish option"
    },
    {
      name: "The Memphis",
      size: "15' x 9'",
      image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-memphis.jpg",
      description: "Perfect backyard retreat"
    },
    {
      name: "The Cheyenne",
      size: "17' x 9'",
      image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-cheyenne.jpg",
      description: "Beautifully crafted design"
    },
    {
      name: "The Atlantis",
      size: "26' x 13'",
      image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-atlantis.jpg",
      description: "Transform your backyard into serene oasis"
    },
    {
      name: "The Kingsbury",
      size: "25' x 12'",
      image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-kingsbury.jpg",
      description: "Versatile design with timeless beauty"
    }
  ],
  medium: [
    {
      name: "The Phoenix",
      size: "30' x 14'",
      image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-phoenix.jpg",
      description: "Sleek and durable design"
    },
    {
      name: "The Santa Fe",
      size: "32' x 14'",
      image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-santa-fe.jpg",
      description: "Stylish and inviting addition"
    },
    {
      name: "The Savannah",
      size: "32' x 16'",
      image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-savannah.jpg",
      description: "Classic design with modern functionality"
    },
    {
      name: "The Cabo",
      size: "33' x 16'",
      image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-cabo.jpg",
      description: "Elegance and functionality combined"
    },
    {
      name: "The Malibu",
      size: "33'4\" x 12'6\"",
      image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-malibu.jpg",
      description: "Elegant design perfect centerpiece"
    }
  ],
  large: [
    {
      name: "The Laguna",
      size: "33'4\" x 15'6\"",
      image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-laguna.jpg",
      description: "Beautifully designed large pool"
    },
    {
      name: "The Vegas",
      size: "39'2\" x 13'9\"",
      image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-vegas.jpg",
      description: "Spacious and stylish design"
    },
    {
      name: "The Charleston",
      size: "37' x 16'",
      image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-charleston.jpg",
      description: "Durability and elegance combined"
    },
    {
      name: "The Independence",
      size: "44'6\" x 18'",
      image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-independence.jpg",
      description: "Ultimate staycation retreat"
    }
  ]
};

export const spaModels = [
  {
    name: "The Aspen",
    size: "10' x 8'",
    image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-aspen-with-jets.jpg",
    description: "Ideal for transforming your backyard into a serene oasis"
  },
  {
    name: "The Arlington",
    size: "8'2\" x 9'2\"",
    image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-arlington.jpg",
    description: "Compact yet striking design"
  },
  {
    name: "The Boston",
    size: "88\" x 90\"",
    image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-boston.jpg",
    description: "Ideal finishing touch for your backyard retreat"
  },
  {
    name: "The Dallas",
    size: "10'5\" x 8'5\"",
    image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-dallas.jpg",
    description: "Perfect spa for your backyard retreat"
  },
  {
    name: "The Flagstaff",
    size: "93\" x 93\"",
    image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-flagstaff.jpg",
    description: "Versatile design for any backyard"
  },
  {
    name: "The Portland",
    size: "Custom",
    image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-portland.jpg",
    description: "Luxurious and durable in-ground spa"
  },
  {
    name: "The Serenity",
    size: "18'2\" x 9'6\"",
    image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-serenity.jpg",
    description: "Spacious and tranquil swim spa setting"
  },
  {
    name: "The Tahoe",
    size: "12'1\" x 8'1\"",
    image: "https://lonestarcomponents.com/wp-content/uploads/2025/06/LSC_dig_diagrams-DEALER-tahoe.jpg",
    description: "Combines durability and elegance"
  }
];
